import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { FarmerDetails } from 'src/app/models/farmer-details.model';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss'],
  providers: [MessageService, DatePipe]

})
export class PersonalDetailsComponent implements OnInit {
  farmersDetailsForm: FormGroup;
  filteredVillage: any[];
  isSubmitted = false;
  isLoading = false;
  villageList: { Code: number, Name: string }[];
  famerID: string = '';
  genderType: string;
  selectedVillage: any;
  isEditable: any;
  todayDate: Date;
  farmerData: any;
  ipAddress: any = '000.000.000';
  isCasteCertificateMandatory: boolean = false;
  isCasteCertificteOptional: boolean = false;
  isAadharVerified: boolean = false;
  showAadharVerDialog: boolean = false;
  aadharNumber: any;
  aadharVerOTP: number;
  timer: number = 60;
  intervalId: any;

  public subscriptions: any = []
  public subjectSub: any;
  public openPPIDDialog: boolean = false;
  // public isMemberIdFound: boolean = false;
  // public PPPIdValue: any;
  public memberIdOTPValue: any;
  public pppIDData: any;
  public showPPPIdValidationBox: boolean = true;
  public isAadharNumberFound: boolean = false;
  public isPPPDataNotValidated: boolean = true;

  public fetchedFamilyData: any;
  public fetchedMemberId: any;
  public fetchedFamilyId: any;

  public showStatusMessage: boolean = false;
  public statusMessageText: any = 'nothingggg';
  public isErrorStatus: boolean = false;
  public farmerMobileNo: any;

  public isNotRegistered: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    this.farmerMobileNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';

    this.getIP();
    this.todayDate = new Date();
    this.farmersDetailsForm = this._fb.group({
      farmersName: ['', Validators.required],
      fathersName: ['', Validators.required],
      mothersName: ['', Validators.required],
      gender: ['', Validators.required],
      dob: ['', Validators.required],
      pppId: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      aadharNo: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(12)]],
      aadharPhotoPath: ['', Validators.required],
      mobileNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      caste: ['', Validators.required],
      address: ['', Validators.required],
      pincode: ['', Validators.required],
      emailId: ['', Validators.compose([Validators.required, Validators.email])],
      village: [this.selectedVillage, Validators.required],
      pppPhotoPath: ['', Validators.required],
      farmersPhotoPath: ['', Validators.required],
      casteCertificate: ['', Validators.required],
      mfmbNo: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
    });
    

    const farmerData = farmerconfData.get('farmerDetails');
    if(farmerData){
      this.populateData(farmerData);
    }else{
      this.LoadFarmerDetails();
    }
    // this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      // this.loader.close();
      this.villageList = res;
      this.filteredVillage = [...this.villageList]

      if (this.farmerData?.Village_Code) {
        let village = this.villageList?.filter(val => val?.Code === this.farmerData?.Village_Code)[0]
        this.farmersFormControls.village.setValue(village?.Name);
        this.selectedVillage = village;
      }

      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
    this.getCasteMaster()

  }
  getCasteMaster() {
    // this.loader.start();
    this._personalDetalSer.getCasteMatserData().subscribe(res => {
      // this.loader.close();
    })
  }

  populateData(farmerData) {
    if (farmerData) {
      this.isLoading = true;
      this.farmerData = farmerData;
      this.isEditable = farmerData.IsEdit;

      this.farmersFormControls.pppId.setValue(farmerData.PPP_ID);
      this.farmersFormControls.farmersName.setValue(farmerData.Name);
      this.farmersFormControls.fathersName.setValue(farmerData.Father_name);
      this.farmersFormControls.mothersName.setValue(farmerData.Mother_Name);
      this.farmersFormControls.address.setValue(farmerData.Address);
      this.farmersFormControls.mobileNo.setValue(farmerData.Mobile);
      // this.farmersFormControls.dob.setValue(dob[2] + '-' + dob[1] + '-' + dob[0]);
      this.farmersFormControls.dob.setValue(new Date(farmerData.DOB));
      this.farmersFormControls.pincode.setValue(farmerData.Pin_Code);
      this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
      this.farmersFormControls.aadharNo.setValue(farmerData.Aadhar_No);
      if (farmerData.Aadhar_No && farmerData.Aadhar_No != null) {
        this.isAadharNumberFound = true;
        this.aadharNumber = farmerData.Aadhar_No;
      } else {
        this.isAadharNumberFound = false;
        this.aadharNumber = null;
      }
      this.farmersFormControls.caste.setValue(farmerData.Caste_Code);
      this.onCasteChange('', farmerData.Caste_Code)
      // if(farmerData?.Caste_Code == 3){
      //   this.isCasteCertificateMandatory = true;
      // }else if(farmerData?.Caste_Code){
      //   this.isCasteCertificteOptional = true;
      // }else{
      //   this.isCasteCertificateMandatory = false;
      //   this.isCasteCertificteOptional = false;
      // }
      // this.farmersFormControls.idProof.setValue(farmerData.IDproof_Type);
      this.farmersFormControls.gender.setValue(farmerData.Gender);
      this.farmersFormControls.mfmbNo.setValue(farmerData.MFMBNo);
      this.genderType = farmerData.Gender;
      this.farmersFormControls.farmersPhotoPath.setValue(farmerData.Farmer_Photo);
      if (farmerData?.CasteCertificate_Path) {
        this.farmersFormControls.casteCertificate.setValue(farmerData.CasteCertificate_Path);
      }
      // this.farmersFormControls.idProofPhotoPath.setValue(farmerData.ID_Proof_FilePath);
      this.farmersFormControls.aadharPhotoPath.setValue(farmerData.Aadhaar_Copy_Upload);
      this.farmersFormControls.pppPhotoPath.setValue(farmerData.ID_Proof_FilePath)
      let village = this.villageList?.filter(val => val?.Code === farmerData?.Village_Code)[0]
      this.farmersFormControls.village.setValue(village?.Name);
      this.selectedVillage = village;
      if (farmerData?.IsAadharValidated == 1) {
        this.isAadharVerified = true;
      } else {
        this.isAadharVerified = false;
      }

      
      setTimeout(() => {
        // this.loader.close();
        this.isLoading = false;
      }, 0)
    }
  }

  LoadFarmerDetails() {
    this.isNotRegistered = false;
    // this.loader.start();
    this.isLoading = true;
    let phNo = this.farmerMobileNo;

    let reqBody = {
      MobileNo : phNo
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    let sub = this._personalDetalSer.getFarmerDetails(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));
          // this.loader.close();
          this.isLoading = false;
          if (data) {
            // this.activityRecordService.activityRecord(phNo, 'Personal Details', '', new Date(), 'Success');
            let farmerData = data[0];
            if (farmerData) {
              // this.loader.start();
              this.isLoading = true;
              this.farmerData = farmerData;
              this.isEditable = farmerData.IsEdit;
              // let dob = farmerData.DOB.split('T')[0].split('-');

              this.farmersFormControls.pppId.setValue(farmerData.PPP_ID);
              this.farmersFormControls.farmersName.setValue(farmerData.Name);
              this.farmersFormControls.fathersName.setValue(farmerData.Father_name);
              this.farmersFormControls.mothersName.setValue(farmerData.Mother_Name);
              this.farmersFormControls.address.setValue(farmerData.Address);
              this.farmersFormControls.mobileNo.setValue(farmerData.Mobile);
              // this.farmersFormControls.dob.setValue(dob[2] + '-' + dob[1] + '-' + dob[0]);
              this.farmersFormControls.dob.setValue(new Date(farmerData.DOB));
              this.farmersFormControls.pincode.setValue(farmerData.Pin_Code);
              this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
              this.farmersFormControls.aadharNo.setValue(farmerData.Aadhar_No);
              if (farmerData.Aadhar_No && farmerData.Aadhar_No != null) {
                this.isAadharNumberFound = true;
                this.aadharNumber = farmerData.Aadhar_No;
              } else {
                this.isAadharNumberFound = false;
                this.aadharNumber = null;
              }
              this.farmersFormControls.caste.setValue(farmerData.Caste_Code);
              this.onCasteChange('', farmerData.Caste_Code)
              // if(farmerData?.Caste_Code == 3){
              //   this.isCasteCertificateMandatory = true;
              // }else if(farmerData?.Caste_Code){
              //   this.isCasteCertificteOptional = true;
              // }else{
              //   this.isCasteCertificateMandatory = false;
              //   this.isCasteCertificteOptional = false;
              // }
              // this.farmersFormControls.idProof.setValue(farmerData.IDproof_Type);
              this.farmersFormControls.gender.setValue(farmerData.Gender);
              this.farmersFormControls.mfmbNo.setValue(farmerData.MFMBNo);
              this.genderType = farmerData.Gender;
              this.farmersFormControls.farmersPhotoPath.setValue(farmerData.Farmer_Photo);
              if (farmerData?.CasteCertificate_Path) {
                this.farmersFormControls.casteCertificate.setValue(farmerData.CasteCertificate_Path);
              }
              // this.farmersFormControls.idProofPhotoPath.setValue(farmerData.ID_Proof_FilePath);
              this.farmersFormControls.aadharPhotoPath.setValue(farmerData.Aadhaar_Copy_Upload);
              this.farmersFormControls.pppPhotoPath.setValue(farmerData.ID_Proof_FilePath)
              let village = this.villageList?.filter(val => val?.Code === farmerData?.Village_Code)[0]
              this.farmersFormControls.village.setValue(village?.Name);
              this.selectedVillage = village;
              if (farmerData?.IsAadharValidated == 1) {
                this.isAadharVerified = true;
              } else {
                this.isAadharVerified = false;
              }

              const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
              const farmerconfData = new Map(encData);

              farmerconfData.set('farmerDetails', farmerData);
              farmerconfData.set('AadharStatus_', farmerData?.AadharStatus);
              farmerconfData.set('Farmer_Id_', farmerData?.Farmer_ID);

              const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
              sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));
              setTimeout(() => {
                // this.loader.close();
                this.isLoading = false;
              }, 2000)

            }
          }
        },
        error: (err) => {
          // this.loader.close();
          this.isLoading = false;
          // this.activityRecordService.activityRecord(phNo, 'Personal Details', '', new Date(), err);

          this.farmersFormControls.mobileNo.setValue(phNo);

          if(err.message == "Not Registered"){
            this.isNotRegistered = true;
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `${err.message}. Complete your KYC` });
          }else{
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Details not found.' });
          }
          // this.router.navigate(['/personal-details']);
        }
      });

    this.subscriptions.push(sub);

    // if (farmerData) {
    //   let dob = farmerData.DOB.split('T')[0].split('-');

    //   this.farmersFormControls.pppId.setValue(farmerData.PPP_ID);
    //   this.farmersFormControls.farmersName.setValue(farmerData.Name);
    //   this.farmersFormControls.fathersName.setValue(farmerData.Father_name);
    //   this.farmersFormControls.mothersName.setValue(farmerData.Mother_Name);
    //   this.farmersFormControls.address.setValue(farmerData.Address);
    //   this.farmersFormControls.mobileNo.setValue(farmerData.Mobile);
    //   this.farmersFormControls.dob.setValue(dob[1] + '-' + dob[2] + '-' + dob[0]);
    //   // this.farmersFormControls.dob.setValue(farmerData.DOB);
    //   this.farmersFormControls.pincode.setValue(farmerData.Pin_Code);
    //   this.farmersFormControls.emailId.setValue(farmerData.Email_ID);
    //   this.farmersFormControls.aadharNo.setValue(farmerData.Aadhar_No);
    //   this.farmersFormControls.caste.setValue(farmerData.Caste_Code);
    //   this.farmersFormControls.gender.setValue(farmerData.Gender);
    //   this.farmersFormControls.village.setValue(farmerData.Village_Code);
    //   this.farmersFormControls.idProof.setValue(farmerData.IDproof_Type);

    // }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  get farmersFormControls() {
    return this.farmersDetailsForm.controls;
  }
  filterVillage(event: any) {

    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;

  }

  onUpdateDoc() {
    this.isSubmitted = true;
    let val = this.farmersDetailsForm.value;
    let isAutomatedData = this.farmerData?.IsAutomatedData == 1 ? 1 : 0;
    const data = this.mapDataToFarmersModel(isAutomatedData);
    if (!(val.pppPhotoPath == '' || val.aadharPhotoPath == '')) {
      this._update(data);
    }
  }

  onFarmersFormSubmit() {
    this.isSubmitted = true;

    // if(this.farmersDetailsForm.valid && !this.isAadharVerified){
    //   this.messageService.add({ severity: 'error', summary: 'Aadhar Error', detail: 'Verify your Aadhar number' });
    //   return;
    // }

    if (this.farmersDetailsForm.valid) {
      // this.isLoading = true;

      const data = this.mapDataToFarmersModel(0);


      const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
      const farmerConfData = new Map(encData);
      let farmerData = farmerConfData.get('farmerDetails');

      if (farmerData) {
        this._update(data);
      } else {
        // this._insert(data);
      }
    }
  }

  _update(data_) {
    let phNo = this.farmerMobileNo;

    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(data_))
    }

    this.loader.start();
    // let reqBody = this.cryptoJsService.EncryptPayload(data_)
    this._personalDetalSer.updateFarmersData(reqBodyFinal).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.isLoading = false;
    
          if (data == "Farmer Details Updated Successfully!") {
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Details updated Successfully.' });

            let reqBody = {
              MobileNo : this.farmersDetailsForm.controls.mobileNo.value
            }
        
            let reqBodyAfterEncypt = {
              "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
            }

            this._personalDetalSer.getFarmerDetails(reqBodyAfterEncypt)
            .pipe(first())
            .subscribe({
              next: (data) => {
                if (data) {
                  const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
                  const farmerconfData = new Map(encData);

                  farmerconfData.set('farmerDetails', data.Table[0]);

                  const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
                  sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));

                  setTimeout(()=> {
                    location.reload();
                  }, 1500)
                }
              }
            });
          } else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
          }

          // this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), data, JSON.stringify(data_))

        },
        error: (err) => {
          this.loader.close();
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Details not saved.' });
          // this.activityRecordService.activityRecord(phNo, 'Update Personal Details', '', new Date(), err, JSON.stringify(data_));
        }
      });
  }

  _insert(data_) {
    let phNo = this.farmerMobileNo;

    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(data_))
    }

    this.loader.start();
    // let reqBody = this.cryptoJsService.EncryptPayload(data_)
    this._personalDetalSer.postFarmersData(reqBodyFinal).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.isLoading = false;

          let reqBody = {
            MobileNo : this.farmersDetailsForm.controls.mobileNo.value
          }
      
          let reqBodyAfterEncypt = {
            "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
          }

          this._personalDetalSer.getFarmerDetails(reqBodyAfterEncypt)
            .pipe(first())
            .subscribe({
              next: (resp) => {
                let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));

                if (data) {
                  const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
                  const farmerconfData = new Map(encData);

                  farmerconfData.set('farmerDetails', data[0]);

                  const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
                  sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));
                }
              }
            });
          if (data == "Farmer Details Saved Successfully! ") {
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Details saved Successfully.' });
            location.reload();
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data });
          }

          // this.activityRecordService.activityRecord(phNo, 'Insert Personal Details', '', new Date(), data, data_);


        },
        error: (err) => {
          this.loader.close();
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Farmer Details not saved.' });

          // this.activityRecordService.activityRecord(phNo, 'Insert Personal Details', '', new Date(), err, data_);
        }
      });

  }

  mapDataToFarmersModel(isautomatedData): FarmerDetails {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');
    let userID_ = String(farmerConfData.get('userID'));

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    if (farmerData) {
      // this.famerID = farmerData?.['Farmer_ID'];
      this.famerID = farmerConfData.get('Farmer_Id_') as string;
    }
    let data: FarmerDetails = {};
    //The below snippet converts the DOB into required format to populate 'data.dob' below
    let DOB: Date;
    let values = this.farmersDetailsForm.controls.dob.value.toString().split('-');
    if (values.length) {
      //Replacing DD MM to MM DD Format.
      values.splice(1, 0, values.shift());
      DOB = values.join(" ");
    }


    data.farmerID = this.famerID;
    data.ppP_ID = this.farmersDetailsForm.value['pppId'];
    data.farmerphoto_path = this.farmersDetailsForm.value['farmersPhotoPath'];
    data.casteCertificate_Path = this.farmersDetailsForm.value['casteCertificate'];
    data.name = this.farmersDetailsForm.value['farmersName'];
    data.farmerFatherName = this.farmersDetailsForm.value['fathersName'];
    data.farmerMotherName = this.farmersDetailsForm.value['mothersName'];
    data.address = this.farmersDetailsForm.value['address'];
    data.mobileno = this.farmersDetailsForm.value['mobileNo'];
    data.ppP_path = this.farmersDetailsForm.value['pppPhotoPath'];
    data.dob = this.farmersDetailsForm.controls.dob.value ? this.datePipe.transform(this.farmersDetailsForm.controls.dob.value, 'yyyy-MM-dd') : '1900-01-01';
    // data.dob = DOB ? this.toISOLocal(new Date(DOB)).replace(/.\d+Z$/g, "") : this.toISOLocal(new Date((this.farmersDetailsForm.controls.dob.value))).replace(/.\d+Z$/g, "");
    data.pincode = this.farmersDetailsForm.value['pincode'];;
    data.emailid = this.farmersDetailsForm.value['emailId'];
    data.aadharno = this.farmersDetailsForm.value['aadharNo'];
    data.aadhar_path = this.farmersDetailsForm.value['aadharPhotoPath'];
    data.castcode = this.farmersDetailsForm.value['caste'];
    data.gender = this.farmersDetailsForm.value['gender'];
    data.villagecode = this.farmersDetailsForm.value['village'].Code;
    data.mfmbNo = this.farmersDetailsForm.value['mfmbNo'];
    data.idproof = "aadhar";
    data.active = '1';
    data.userID = userId ? String(userId) : String(userID_)
    data.area_Already_Apply = 0;
    data.fid = '123451111';
    data.network_ID = this.ipAddress;
    data.terminal_ID = this.ipAddress;
    data.is_Atal = sessionStorage.getItem("isAtalBhujal") === '1' || sessionStorage.getItem("isVendor") === '1' ? true : false;
    data.isAutomatedData = isautomatedData;
    data.autoId = 0;
    data.memberId = '';

    return data;
  }

  onFarmerPhotoUpload(event) {
    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded with Auto Mode' });
  }
  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    let phNo = this.farmerMobileNo;
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      if (resp.statusCode == 200) {
        this.farmersDetailsForm.patchValue({ [formcontrol]: resp.data });
      }

    })
    uploadElement.clear();

  }

  getVillageData() {
    this.loader.start();
    this._personalDetalSer.getVillageMatserData().subscribe(res => {
      this.loader.close();
      this.villageList = res;
      this.filteredVillage = [...this.villageList]
      if (!window.localStorage.getItem("villageMaster")) {
        window.localStorage.setItem("villageMaster", JSON.stringify(res));
      }
    })
  }

  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return d.getFullYear() + '-'
      + z(d.getMonth() + 1) + '-' +
      z(d.getDate());
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  onCasteChange(event, ...value) {
    this.isCasteCertificateMandatory = false;
    let val = 0;
    if (value.length > 0) {
      val = value[0];
    } else {
      val = this.farmersDetailsForm.value['caste'];
    }
    if (val == 1) {
      this.isCasteCertificteOptional = false;
      this.isCasteCertificateMandatory = false;
      this.farmersDetailsForm.controls['casteCertificate'].clearValidators();
      this.farmersDetailsForm.controls['casteCertificate'].updateValueAndValidity();
      this.farmersFormControls.casteCertificate.setValue('');
    } else if (val == 2) {
      this.isCasteCertificteOptional = true;
      this.isCasteCertificateMandatory = false;
      this.farmersDetailsForm.controls['casteCertificate'].clearValidators();
      this.farmersDetailsForm.controls['casteCertificate'].updateValueAndValidity();
      this.farmersFormControls.casteCertificate.setValue('');
    } else {
      this.isCasteCertificteOptional = false;
      this.isCasteCertificateMandatory = true;
      this.farmersDetailsForm.controls['casteCertificate'].setValidators(Validators.required);
      this.farmersDetailsForm.controls['casteCertificate'].updateValueAndValidity();
    }
  }

  // verifyAadhar() {
  //   // this.aadharNumber = this.farmersDetailsForm.value['aadharNo'];
  //   this.validateAadharNumber(this.aadharNumber);
  //   // this.showAadharVerDialog = true;
  //   // this.startTimer();
  // }

  // validateAadharNumber(aadharNumber) {
  //   let phNo = this.farmerMobileNo;
  //   this.loader.start();
  //   this._personalDetalSer.validateAadhar(aadharNumber).pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loader.close();

  //         if (data == "OTP sent") {
  //           this.showAadharVerDialog = true;
  //           this.startTimer();
  //           this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'OTP Sent Successfully.' });
  //         } else {
  //           this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
  //         }

  //         // this.activityRecordService.activityRecord(phNo, 'Validate Aadhar Number', '', new Date(), data, aadharNumber);
  //       },
  //       error: (err) => {
  //         this.loader.close();
  //         this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

  //         // this.activityRecordService.activityRecord(phNo, 'Validate Aadhar Number(error)', '', new Date(), err, aadharNumber);
  //       }
  //     });
  // }

  hideDialog() {
    this.showAadharVerDialog = false;
    this.aadharVerOTP = null;
  }

  submitOTP() {
    this.validateOTP(this.aadharNumber, this.aadharVerOTP)
  }

  validateOTP(aadharNumber, otp) {
    let phNo = this.farmerMobileNo;
    this.loader.start();
    this._personalDetalSer.validateOTP(aadharNumber, otp, '').pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.startsWith('s') || data.startsWith('S')) {
            this.isAadharVerified = true;
            this.hideDialog();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Aadhar Validated Successfully.' });
          } else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
          }

          // this.activityRecordService.activityRecord(phNo, 'Validate OTP For Aadhar Verification', '', new Date(), data, aadharNumber);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          // this.activityRecordService.activityRecord(phNo, 'Validate OTP For Aadhar Verification', '', new Date(), err, aadharNumber);
        }
      });
  }


  startTimer(): void {
    this.intervalId = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  resendOTP(): void {
    // Reset timer
    this.timer = 60;
    // Start timer again
    this.startTimer();
  }

  editAadharNumber() {
    this.hideDialog();
  }

  findMemberIdFromUID() {
    this.showStatusMessage = true;
    this.getMemberIdFromUID();
  }

  clearPPPIdData() {
    // this.isMemberIdFound = false;
    // this.PPPIdValue = null;
    this.memberIdOTPValue = null;
    // this.pppIDData = null;
    this.showPPPIdValidationBox = true;
    this.fetchedFamilyData = null;
    this.statusMessageText = null;
    this.showStatusMessage = false;
  }

  hidePPIDDialog() {
    this.openPPIDDialog = false;
    this.clearPPPIdData();
  }

  // sendPPIDOTP(){
  getMemberIdFromUID() {
    let phNo = this.farmerMobileNo;
    this.loader.start();
    // this._personalDetalSer.getFamilyIdByUID(this.aadharNumber).pipe(first())
    this._personalDetalSer.getFamilyIdByUID('', '200411089222').pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.message == "Record Match") {

            this.isErrorStatus = false;
            this.statusMessageText = 'PPP Id fetched from Aadhar Number. Verifying it...'

            this.fetchedFamilyData = data.result[0];
            this.fetchedMemberId = this.fetchedFamilyData.memberid;
            this.fetchedFamilyId = this.fetchedFamilyData.familyid;

            this.verifyPPPId(this.famerID, this.fetchedFamilyId);
            // this.isMemberIdFound = true;

            this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Family Id Fetched' });
          } else {

            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`

            this.messageService.add({ severity: 'info', summary: data.message, detail: data });
          }

          // this.activityRecordService.activityRecord(phNo, 'Validate Aadhar Number', '', new Date(), data, aadharNumber);
        },
        error: (err) => {
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          // this.activityRecordService.activityRecord(phNo, 'Validate Aadhar Number(error)', '', new Date(), err, aadharNumber);
        }
      });
  }

  verifyPPPId(farmerId, familyId) {
    this.loader.start();
    this._personalDetalSer.getVerifyPPPID(farmerId, familyId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          data = data[0].Column1;
          // if(data == "Record matched"){
          if (data == "Record not matched") {
            this.openPPIDDialog = true;

            this.isErrorStatus = false;
            this.statusMessageText = data;

            this.sendOTPforMEMID();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: data });
          } else {
            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`

            this.messageService.add({ severity: 'error', summary: 'Error', detail: data });
          }
        },
        error: (err) => {
          this.loader.close();
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          this.openPPIDDialog = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  sendOTPforMEMID() {
    this.loader.start();
    this._personalDetalSer.OTPRequestforMEMID(this.fetchedMemberId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data == "OTP Sent to registered mobile No.") {
            this.isErrorStatus = false;
            this.statusMessageText = data;

            this.messageService.add({ severity: 'success', summary: 'OTP Sent', detail: data });
          } else {
            this.openPPIDDialog = false;

            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`

            this.messageService.add({ severity: 'error', summary: 'OTP Not Sent', detail: data });
          }
        },
        error: (err) => {
          this.loader.close();
          this.openPPIDDialog = false;

          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  onClickBack() {
    this.showPPPIdValidationBox = true;
    this.clearPPPIdData();
  }

  onSubmitMemIdOTP() {
    this.loader.start();
    this._personalDetalSer.verifyOTPRequestForMID(this.fetchedMemberId, null, this.memberIdOTPValue).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.message == "Record Match") {

            this.isErrorStatus = false;
            this.statusMessageText = data.message;

            this.pppIDData = data.result;

            this.isPPPDataNotValidated = false;
            this.openPPIDDialog = false;

            this.messageService.add({ severity: 'success', summary: data.status, detail: data.message });
          } else {

            this.isErrorStatus = true;
            this.statusMessageText = data.message;

            this.messageService.add({ severity: 'error', summary: data.status, detail: data.message });

          }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }
}
